import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        // Statuses - WCAG 2.1 Contrast Compliant (min 4.5:1)
        pending: "border-transparent bg-yellow-800 text-white hover:bg-yellow-800/80",
        success: "border-transparent bg-green-700 text-white hover:bg-green-700/80",
        Criado: "border-transparent bg-blue-700 text-white hover:bg-blue-700/80",
        Pendente: "border-transparent bg-yellow-800 text-white hover:bg-yellow-800/80",
        "Pedido Realizado de Contrato": "border-transparent bg-blue-700 text-white hover:bg-blue-700/80",
        Processando: "border-transparent bg-orange-700 text-white hover:bg-orange-700/80",
        Processado: "border-transparent bg-cyan-700 text-white hover:bg-cyan-700/80",
        Faturado: "border-transparent bg-indigo-700 text-white hover:bg-indigo-700/80",
        "Nota Emitida": "border-transparent bg-purple-700 text-white hover:bg-purple-700/80",
        "Em Rota": "border-transparent bg-teal-700 text-white hover:bg-teal-700/80",
        Entregue: "border-transparent bg-green-700 text-white hover:bg-green-700/80",
        Cancelado: "border-transparent bg-gray-600 text-white hover:bg-gray-600/80",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
  VariantProps<typeof badgeVariants> { }

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ( { className, variant, ...props }, ref ) => {
    return (
      <div
        ref={ref}
        className={cn( badgeVariants( { variant } ), className )}
        {...props}
      />
    )
  }
)
Badge.displayName = "Badge"

export { Badge, badgeVariants }
